import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Navbar } from 'react-bootstrap';

import logo from 'components/Auth/login/key.svg';
import s from './TopNavigation.scss'; // eslint-disable-line css-modules/no-unused-class

class TopNavigation extends React.Component {
  render() {
    return (
      <Navbar
        className={s.navbar}
        fixedTop
        fluid
        collapseOnSelect
        onSelect={k => this.handleSelect(k)}
      >
        <Navbar.Header>
          <Navbar.Brand className={s.logoContainer}>
            <a href="/app/dashboard">
              <div className={`${s.logoIcon} ${s.hideMobileMini}`}>
                <img src={logo} alt="" />
                <span>Waltzing License</span>
              </div>
              <div className={`${s.logoIcon} ${s.showMobile}`}>
                <img src={logo} alt="" />
              </div>
            </a>
          </Navbar.Brand>
        </Navbar.Header>
      </Navbar>
    );
  }
}

export default withStyles(s)(TopNavigation);
